import React from 'react';
import { RotateCcw, Trash2, Archive } from 'lucide-react';
import { Button } from '../ui/button';
import { CategoryChip } from '../../pages/Dashboard';

const fmt = (d) => (d ? new Date(d).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' }) : '—');

export const ArchivedTasks = ({ list, onRestore, onDelete, onPurge }) => (
  <div className="rounded-xl bg-white border border-stone-200 overflow-hidden" data-testid="archived-tasks">
    <div className="p-5 border-b border-stone-100 flex items-center justify-between gap-3">
      <div>
        <div className="font-semibold text-stone-900 flex items-center gap-2"><Archive size={16} className="text-emerald-800"/> Archived tasks</div>
        <div className="text-xs text-stone-500 mt-0.5">Done tasks are archived automatically after 30 days. Restore one to bring it back to Done.</div>
      </div>
      {list.length > 0 && (
        <Button size="sm" variant="outline" onClick={onPurge} className="text-red-700 border-red-200 hover:bg-red-50 hover:text-red-800" data-testid="purge-archived-btn">
          <Trash2 size={14} className="mr-1.5"/> Delete all permanently
        </Button>
      )}
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-stone-50 text-stone-600 text-xs uppercase tracking-wider">
          <tr>{['Task', 'Category', 'Client', 'Assignee', 'Completed', 'Archived', ''].map((h, i) => <th key={h || i} className="text-left px-5 py-3 font-medium">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-stone-100">
          {list.length === 0 && <tr><td colSpan={7} className="px-5 py-10 text-center text-stone-500" data-testid="archived-empty">Nothing archived yet.</td></tr>}
          {list.map((t) => (
            <tr key={t.id} className="hover:bg-stone-50" data-testid={`archived-row-${t.id}`}>
              <td className="px-5 py-3 font-medium text-stone-700">{t.title}</td>
              <td className="px-5 py-3"><CategoryChip category={t.category || 'Other'}/></td>
              <td className="px-5 py-3 text-stone-600">{t.clientName || '—'}</td>
              <td className="px-5 py-3 text-stone-600">{t.assignee}</td>
              <td className="px-5 py-3 text-stone-600">{fmt(t.completedAt)}</td>
              <td className="px-5 py-3 text-stone-600">{fmt(t.archivedAt)}</td>
              <td className="px-5 py-3 text-right whitespace-nowrap">
                <button onClick={() => onRestore(t)} className="inline-flex items-center gap-1 px-2 py-1 rounded text-xs text-emerald-800 hover:bg-emerald-50" data-testid={`archived-restore-${t.id}`}><RotateCcw size={13}/> Restore</button>
                <button onClick={() => onDelete(t)} className="p-1 ml-1 text-stone-400 hover:text-red-600" title="Delete permanently" data-testid={`archived-delete-${t.id}`}><Trash2 size={15}/></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
